import React from "react";

import styles from "./NotFound.module.scss";

const NotFound = () => {
  return <div className={styles.notFound}>Not found | 404</div>;
};

export default NotFound;
